"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AccountCheckController_1 = __importDefault(require("./controllers/AccountCheckController"));
var AccountConversionController_1 = __importDefault(require("./controllers/AccountConversionController"));
var TokenController_1 = __importDefault(require("./controllers/TokenController"));
var TxSignatureController_1 = __importDefault(require("./controllers/TxSignatureController"));
var AccountCheckService_1 = __importDefault(require("./services/AccountCheckService"));
var AccountConversionService_1 = __importDefault(require("./services/AccountConversionService"));
var TokenService_1 = __importDefault(require("./services/TokenService"));
var TxSignatureService_1 = __importDefault(require("./services/TxSignatureService"));
var AccountHandler = /** @class */ (function () {
    function AccountHandler() {
    }
    AccountHandler.prototype.convertAccountIdToAccountRs = function (accountId) {
        var controller = new AccountConversionController_1.default(new AccountConversionService_1.default());
        return controller.idToRs(accountId);
    };
    AccountHandler.prototype.convertPassphraseToPublicKey = function (passphrase, toByteArray) {
        if (toByteArray === void 0) { toByteArray = false; }
        var controller = new AccountConversionController_1.default(new AccountConversionService_1.default());
        return controller.passphraseToPublicKey(passphrase, toByteArray);
    };
    AccountHandler.prototype.convertPublicKeyToAccountId = function (publicKey) {
        var controller = new AccountConversionController_1.default(new AccountConversionService_1.default());
        return controller.publicKeyToId(publicKey);
    };
    AccountHandler.prototype.convertPublicKeyToAccountRs = function (publicKey) {
        var controller = new AccountConversionController_1.default(new AccountConversionService_1.default());
        return controller.publicKeyToRs(publicKey);
    };
    AccountHandler.prototype.convertPassphraseToAccountId = function (passphrase) {
        var controller = new AccountConversionController_1.default(new AccountConversionService_1.default());
        return controller.passphraseToId(passphrase);
    };
    AccountHandler.prototype.convertPassphraseToAccountRs = function (passphrase) {
        var controller = new AccountConversionController_1.default(new AccountConversionService_1.default());
        return controller.passphraseToRs(passphrase);
    };
    AccountHandler.prototype.signTransactionBytes = function (unsignedTransactionBytesHex, passphrase) {
        var controller = new TxSignatureController_1.default(new TxSignatureService_1.default());
        return controller.signBytes(unsignedTransactionBytesHex, passphrase);
    };
    AccountHandler.prototype.verifyTransactionBytes = function (unsignedTransactionBytesHex, transactionType, transactionJSON, publicKey) {
        var controller = new TxSignatureController_1.default(new TxSignatureService_1.default());
        return controller.verifyBytes(unsignedTransactionBytesHex, transactionType, transactionJSON, publicKey);
    };
    AccountHandler.prototype.generateToken = function (message, passphrase, forTestnet) {
        if (forTestnet === void 0) { forTestnet = false; }
        var controller = new TokenController_1.default(new TokenService_1.default());
        return controller.generate(message, passphrase, forTestnet);
    };
    AccountHandler.prototype.checkAccountRs = function (accountRs) {
        var controller = new AccountCheckController_1.default(new AccountCheckService_1.default());
        return controller.run(accountRs);
    };
    return AccountHandler;
}());
exports.default = AccountHandler;
